<template>
  <div id="default_layout" class="">
    <!--
    <NotificationContainer
      v-show="!isNotifierLoaded"   
      @notification-container-loaded="disableGlobalNotification"
    />
    -->

    <slot />
  </div>


</template>

<script>
export default {

  data() {
    return {
      isNotifierLoaded: false
    };
  },
  methods: {
    disableGlobalNotification() {
      this.isNotifierLoaded = true;
    }
  },
  components: {
    //NotificationContainer: () => import("@/components/NotificationContainer.vue"),

  }
};
</script>